(() => {

  function initVariantSummary() {

    document.querySelectorAll('.eg-variant-picker').forEach((picker) => {

      if (picker.dataset.egSummaryReady === 'true') return;

      const variantsScript = picker.querySelector(
        'script[type="application/json"]'
      );

      if (!variantsScript) return;

      let variants = [];

      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (error) {
        return;
      }

      picker.dataset.egSummaryReady = 'true';


      const summary = document.createElement('div');

      summary.className = 'eg-variant-summary';

      summary.innerHTML = `
        <div class="eg-variant-summary__label">
          選択中
        </div>

        <div
          class="eg-variant-summary__selection"
          data-eg-summary-selection
        ></div>

        <div class="eg-variant-summary__bottom">

          <span
            class="eg-variant-summary__price"
            data-eg-summary-price
          ></span>

          <span
            class="eg-variant-summary__stock"
            data-eg-summary-stock
          ></span>

        </div>
      `;


      picker.insertAdjacentElement(
        'afterend',
        summary
      );


      const selectionElement =
        summary.querySelector('[data-eg-summary-selection]');

      const priceElement =
        summary.querySelector('[data-eg-summary-price]');

      const stockElement =
        summary.querySelector('[data-eg-summary-stock]');


      function getSelectedOptions() {

        const selected = [];

        const groups = picker.querySelectorAll(
          '.product-form__input'
        );


        groups.forEach((group) => {

          const checkedRadio =
            group.querySelector(
              'input[type="radio"]:checked'
            );


          if (checkedRadio) {

            selected.push(
              checkedRadio.value
            );

            return;
          }


          const select =
            group.querySelector('select');


          if (select) {

            selected.push(
              select.value
            );

          }

        });


        return selected;

      }


      function findVariant(options) {

        return variants.find((variant) => {

          if (!variant.options) return false;

          return variant.options.every(
            (value, index) =>
              String(value) ===
              String(options[index])
          );

        });

      }


      function formatMoney(cents) {

        const currency =
          window.Shopify?.currency?.active || 'JPY';

        const amount =
          Number(cents) / 100;


        return new Intl.NumberFormat(
          'ja-JP',
          {
            style: 'currency',
            currency: currency,
            maximumFractionDigits:
              currency === 'JPY' ? 0 : 2
          }
        ).format(amount);

      }


      function updateSummary() {

        const selectedOptions =
          getSelectedOptions();

        const variant =
          findVariant(selectedOptions);


        selectionElement.textContent =
          selectedOptions.join(' / ');


        if (!variant) {

          priceElement.textContent = '';

          stockElement.textContent =
            '組み合わせをご確認ください';

          stockElement.classList.add(
            'is-unavailable'
          );

          return;

        }


        priceElement.textContent =
          formatMoney(variant.price);


        if (variant.available) {

          stockElement.textContent =
            '在庫あり';

          stockElement.classList.remove(
            'is-unavailable'
          );

        } else {

          stockElement.textContent =
            '売り切れ';

          stockElement.classList.add(
            'is-unavailable'
          );

        }

      }


      picker.addEventListener(
        'change',
        () => {

          window.setTimeout(
            updateSummary,
            0
          );

        }
      );


      updateSummary();

    });

  }


  document.addEventListener(
    'DOMContentLoaded',
    initVariantSummary
  );


  document.addEventListener(
    'shopify:section:load',
    initVariantSummary
  );


  const observer =
    new MutationObserver(
      initVariantSummary
    );


  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

})();